import * as React from 'react';

const getPersistedTokenData = () => {
  return null;
  // const rawTokenData = window.localStorage.getItem('token-data');
  // if (!rawTokenData) return null;

  // const tokenData = JSON.parse(rawTokenData);

  // const isExpired = Date.now() > tokenData.approxExpires;
  // if (isExpired) return null;
  // return tokenData;
};


export default function useSpotifyAuth() {
  const [state, setState] = React.useState(getPersistedTokenData());

  const updateTokens = ({ accessToken, refreshToken, expiresIn, approxExpires }) => {
    setState({
      ...state,
      accessToken,
      refreshToken,
      expiresIn,
      approxExpires,
    });
  };
  return {
    accessToken: state && state && state.accessToken,
    updateTokens,
  };
}
